export default {
    MEDIA_STATUS_LINK: 'MEDIA_STATUS_LINK',
};
